import { useCallback } from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import type { UsersArchiveSort } from '~/api/types';
import { ArchiveUsersScreen } from '~/features/archive/users/ArchiveUsersScreen';
import { UserArchiveSearchParamsProvider } from '~/features/archive/users/params';
import type {
  ArchivedUsersSearchParams,
  ArchivedUsersSearchParamsHandler,
} from '~/features/archive/users/types';
import { USER_ROLES } from '~/features/auth/roles';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/abbott-administration/archive')({
  component: RouteComponent,
  validateSearch: (search): ArchivedUsersSearchParams => {
    const defaultSortDir = search.sortDir === 'asc' ? 'asc' : 'desc';
    const sortDir = search.sortDir ? defaultSortDir : undefined;

    return {
      page: search.page ? Number(search.page) || 1 : undefined,
      sort: (search.sort as UsersArchiveSort | undefined) ?? undefined,
      search:
        search.search && typeof search.search === 'string'
          ? decodeURI(search.search)
          : undefined,
      sortDir,
    };
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AdminAbbott, USER_ROLES.AbbottUser],
    });
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const onSearchParamsChange: ArchivedUsersSearchParamsHandler = useCallback(
    (onSearch) => navigate({ search: onSearch }),
    [navigate],
  );

  return (
    <UserArchiveSearchParamsProvider
      params={Route.useSearch()}
      onSearchParamsChange={onSearchParamsChange}
    >
      <ArchiveUsersScreen>
        <Outlet />
      </ArchiveUsersScreen>
    </UserArchiveSearchParamsProvider>
  );
}
